/** Material-style alarm glyph used for on-chart drawing alert indicators (TradingView-like). */
export const DRAWING_ALERT_ALARM_PATH =
    'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z'

/**
 * Draw a small alert/alarm icon centered at (cx, cy) in bitmap coordinates.
 * Color should already be the active drawing stroke or inactive secondary text color.
 */
export function drawDrawingAlertIcon(
    ctx: CanvasRenderingContext2D,
    cx: number,
    cy: number,
    color: string,
    hRatio: number,
    vRatio: number
) {
    const size = 14 * Math.min(hRatio, vRatio)
    ctx.save()
    ctx.translate(cx - size / 2, cy - size / 2)
    ctx.scale(size / 24, size / 24)
    ctx.fillStyle = color
    if (typeof Path2D !== 'undefined') {
        ctx.fill(new Path2D(DRAWING_ALERT_ALARM_PATH))
    }
    ctx.restore()
}
